export const IS_DEVELOP =
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === 'develop';
export const IS_STAGING =
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === 'staging';
export const IS_PREPROD =
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === 'preprod';
export const IS_PRODUCTION =
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === 'production';